import {
  Box,
  Button,
  Chip,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  Paper,
  Popover,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makeGetRequest, makeDeleteRequest, makePutRequest } from 'utils/api'
import urls from 'utils/urls'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import moment from 'moment'
import 'moment/locale/fr'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { toInteger } from 'lodash'
import CreateOperationForm from './CreateOperationForm'
import AltPopper from './AltPopper'
import CloseIcon from '@mui/icons-material/Close'
import EditOperationForm from './EditOperationForm'
import AddListeCourse from './AddListeCourse'
import styled from '@emotion/styled'
import ShareIcon from '@mui/icons-material/Share'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const useStyles = styled((theme) => ({
  root: {
    flexGrow: 1,
  },
  scrollContainer: {
    height: 400,
    overflow: 'auto',
    marginBottom: theme.spacing(3),
  },
  scroll: {
    position: 'relative',
    width: '230%',
    backgroundColor: theme.palette.background.paper,
    height: '230%',
  },
  legend: {
    marginTop: theme.spacing(2),
    maxWidth: 300,
  },
  paper: {
    overflow: 'auto',
    background: 'black',
  },
  select: {
    width: 200,
  },
}))

const rows = ['Matin', 'Midi', 'Après-midi', 'Soir']
const mealColors = {
  Matin: { bg: 'rgba(242, 184, 75, 0.14)', border: 'rgba(242, 184, 75, 0.36)', color: '#f2b84b' },
  Midi: { bg: 'rgba(124, 198, 178, 0.14)', border: 'rgba(124, 198, 178, 0.34)', color: '#7cc6b2' },
  'Après-midi': { bg: 'rgba(169, 135, 255, 0.14)', border: 'rgba(169, 135, 255, 0.34)', color: '#a987ff' },
  Soir: { bg: 'rgba(90, 161, 216, 0.14)', border: 'rgba(90, 161, 216, 0.34)', color: '#5aa1d8' },
}

const actionButtonSx = {
  borderRadius: 999,
  textTransform: 'none',
  fontWeight: 850,
  px: 1.8,
  color: '#ffffff',
  borderColor: 'rgba(255,255,255,0.22)',
  '&:hover': { borderColor: 'rgba(255,255,255,0.5)', bgcolor: 'rgba(255,255,255,0.08)' },
}

const taskStatus = []

const Menu = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const navigate = useNavigate()
  const [row, setRow] = useState({})
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [openDetail, setOpenDetail] = useState(false)
  const [loading, setLoading] = useState(false)
  const [openForm, setOpenForm] = useState(false)
  const [editForm, setEditForm] = useState(false)
  const [selectedRowsParams, setSelectedRowsParams] = useState([])

  const [today, setToday] = useState('')
  const [week, setWeek] = useState('')
  const [weekStartDate, setWeekStartDate] = useState('')
  const [days, setDays] = useState([])
  const [weekNo, setWeekNo] = useState(0)

  const [menuItems, setMenuItems] = useState([])
  const [columns, setColumns] = useState(taskStatus)

  const [anchorRef, setAnchorRef] = useState(null)

  useEffect(() => {
    var currentDate = moment()
    setToday('' + currentDate.calendar().slice(0, 11))
    setWeek(
      currentDate.clone().startOf('week').format('DD') +
        '-' +
        currentDate.clone().endOf('week').format('DD MMMM yyyy'),
    )

    var weekStart = moment().clone().startOf('isoWeek')
    var dayss = []

    for (var i = 0; i <= 6; i++) {
      dayss.push(moment(weekStart).add(i, 'days').format('DD MM YYYY'))
    }
    setDays(dayss)

    fetchOperations()
  }, [])
  const onUpdate = async (data) => {
    await makePutRequest(urls.planMealOperations + `${data.id}/`, data, {}, true)
  }
  const onDragEnd = (result, columns, setColumns) => {
    if (!result.destination) return
    const { source, destination } = result

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId]
      const destColumn = columns[destination.droppableId]
      const sourceItems = [...sourceColumn.items]
      const destItems = [...destColumn.items]
      const [removed] = sourceItems.splice(source.index, 1)
      destItems.splice(destination.index, 0, removed)
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      })

      let data = {
        id: toInteger(removed.id),
        Date: moment(destColumn.date, 'DD-MM-yyyy').format('yyyy-MM-DD'),
        Meal: destColumn.Meal,
      }
      onUpdate(data)
    } else {
      const column = columns[source.droppableId]
      const copiedItems = [...column.items]
      const [removed] = copiedItems.splice(source.index, 1)
      copiedItems.splice(destination.index, 0, removed)
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      })
    }
  }
  const fetchOperations = async (val = '', weekN = 0, date = null) => {
    var weekStart = moment().clone().add(weekN, 'week').startOf('isoWeek')
    var weekEnd = moment().clone().add(weekN, 'week').endOf('isoWeek')
    setWeekStartDate(weekStart.format('yyyy-MM-DD'))
    let url = `${urls.planMealOperations}?limit=100&from=${weekStart.format(
      'yyyy-MM-DD',
    )}&to=${weekEnd.format('yyyy-MM-DD')}`
    if (isMobile) {
      let sdate = date
      if (!date) {
        sdate = moment()
      }
      url = `${urls.planMealOperations}?limit=100&from=${sdate.format(
        'yyyy-MM-DD',
      )}&to=${sdate.format('yyyy-MM-DD')}`
    }

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      var dayss = []

      for (var i = 0; i <= 6; i++) {
        dayss.push(moment(weekStart).add(i, 'days').format('DD-MM-yyyy'))
      }
      if (isMobile) {
        dayss = [moment().format('DD-MM-yyyy')]
      }

      let todaydate = moment().format('DD-MM-yyyy')
      let results = response.data.results
      setMenuItems(results)
      let columns = []
      rows.forEach((v) => {
        dayss.forEach((d) => {
          let items = []
          results.filter((i) => {
            if (i.Date === d && i.Meal === v) {
              items.push({ ...i, id: '' + i.id })
            }
            return i
          })

          columns.push({
            box: d === todaydate ? '#052c6563' : '',
            date: d,
            Meal: v,
            items: items,
          })
        })
      })
      setColumns(columns)
    }
  }
  const PopOver = ({ setOpenDetail, ancRef, row }) => {
    const popover = useRef(null)
    const [anchorRef, setAnchorRef] = useState(ancRef)
    const [open, setOpen] = useState(true)
    const [instructions, setInstructions] = useState([])
    const [ingredients, setIngredients] = useState([])
    const classes = useStyles()

    const handleEventDel = async () => {
      const response = await makeDeleteRequest(urls.planMealOperations + `${row.id}/`, {}, true)
      if (response.status === 204) {
        setOpen((prevOpen) => !prevOpen)
        setOpenDetail(false)
        fetchOperations('', weekNo)
      }
    }
    const handeleEditForm = async () => {
      const response = await makeGetRequest(
        urls.crudRecettesOperations + `${row.RecetteId}/`,
        {},
        true,
      )
      if (response.status === 200) {
        setOpenDetail(false)
        setSelectedRowsParams([response.data])
        setEditForm(true)
      }
    }
    const handleClickButton = () => {
      setOpen((prevOpen) => !prevOpen)
      setOpenDetail(false)
    }
    const handleClickOutside = (event) => {
      if (popover.current && !popover.current.contains(event.target)) {
        setOpen(false)
        setOpenDetail(false)
      }
    }

    useEffect(() => {
      fetchInstructions()
      // document.addEventListener('mousedown', handleClickOutside)
      // return () => {
      //   document.removeEventListener('mousedown', handleClickOutside)
      // }
    }, [])

    const fetchInstructions = async () => {
      setLoading(true)
      let url = `${urls.crudInstructionOperations}?Recette=${row.RecetteId}`
      let url2 = `${urls.crudBillofingredientsOperations}?RecipeId=${row.RecetteId}`

      const response = await makeGetRequest(url, {}, true)
      if (response.status === 200) {
        setInstructions([...response.data.results])
      }
      const response2 = await makeGetRequest(url2, {}, true)
      if (response2.status === 200) {
        setIngredients([...response2.data.results])
      }
    }

    const id = open ? 'scroll-playground' : null

    const ffs = (
      <AltPopper
        // id={id}
        aref={popover}
        open={open}
        arrow={true}
        flip={true}
        transition
        anchorEl={anchorRef}
        disablePortal={false}
        preventOverflow={'scrollParent'}
      >
        {({ TransitionProps, placement, arrow }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box width={isMobile ? '330px' : '600px'}>
              {arrow}
              <Paper className={classes.paper}>
                <DialogTitle>
                  <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    borderBottom={'1px solid white'}
                    color={'black'}
                  >
                    <Box>
                      {row.RecetteNom}
                      <span style={{ marginLeft: '10px', fontStyle: 'italic' }}>
                        {row.Servir} pers.
                      </span>
                    </Box>
                    <Box>
                      <Button onClick={handleClickButton} style={{ color: 'black' }}>
                        <CloseIcon />
                      </Button>
                    </Box>
                  </Box>
                </DialogTitle>
                <DialogContent>
                  <Box
                    display={'flex'}
                    flexDirection={'row'}
                    borderBottom={'1px solid white'}
                    color={'black'}
                  >
                    <Box width={'100%'}>
                      {/* LAP-733 (GE022) */}
                      <Box color={'#7f7f7f'}>{t('planMeal.ingredients')}</Box>
                      {ingredients.length > 0 &&
                        ingredients.map((item) => (
                          <Box key={item.id}>
                            {item.Quantite} {item.NomIngredient}
                          </Box>
                        ))}
                    </Box>
                    <Box width={'100%'}>
                      {/* LAP-733 (GE022) */}
                      <Box color={'#7f7f7f'}>{t('planMeal.instructions')}</Box>
                      {instructions.length > 0 &&
                        instructions.map((item) => (
                          <Box key={item.id}>
                            {item.Numero}. {item.Description}
                          </Box>
                        ))}
                    </Box>
                  </Box>
                </DialogContent>
                <DialogActions>
                  <CustomButton
                    style={{ background: '#3075dd', padding: '5px 20px' }}
                    onClick={handleClickButton}
                  >
                    {/* LAP-733 (GE022) */}
                    {t('planMeal.btnAddToList')}
                  </CustomButton>
                  <CustomButton
                    style={{ background: '#3075dd', padding: '5px 20px' }}
                    onClick={() => {
                      handleClickButton()
                      handeleEditForm()
                    }}
                  >
                    {/* LAP-733 (GE022) */}
                    {t('planMeal.btnEditRecipe')}
                  </CustomButton>
                  <CustomButton
                    style={{ background: '#3075dd', padding: '5px 20px' }}
                    onClick={() => navigate('/recette/' + row.RecetteId)}
                  >
                    {/* LAP-733 (GE022) */}
                    {t('planMeal.btnViewRecipe')}
                  </CustomButton>
                  <CustomButton
                    style={{ background: 'red', padding: '5px 20px', marginLeft: '10px' }}
                    onClick={handleEventDel}
                  >
                    {/* LAP-733 (GE022) */}
                    {t('planMeal.btnDelete')}
                  </CustomButton>
                </DialogActions>
              </Paper>
            </Box>
          </Fade>
        )}
      </AltPopper>
    )
    return (
      <Popover
        // id={id}
        sx={{ position: 'unset' }}
        open={open}
        anchorEl={ancRef}
        // onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box width={isMobile ? '330px' : '600px'}>
          <Paper className={classes.paper}>
            <DialogTitle>
              <Box
                display={'flex'}
                justifyContent={'space-between'}
                borderBottom={'1px solid white'}
                color={'black'}
              >
                <Box>
                  {row.RecetteNom}
                  <span style={{ marginLeft: '10px', fontStyle: 'italic' }}>
                    {row.Servir} pers.
                  </span>
                </Box>
                <Box>
                  <Button onClick={handleClickButton} style={{ color: 'black' }}>
                    <CloseIcon />
                  </Button>
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box
                display={'flex'}
                flexDirection={'row'}
                borderBottom={'1px solid white'}
                color={'black'}
              >
                <Box width={'100%'}>
                  {/* LAP-733 (GE022) */}
                  <Box color={'#7f7f7f'}>{t('planMeal.ingredients')}</Box>
                  {ingredients.length > 0 &&
                    ingredients.map((item) => (
                      <Box key={item.id}>
                        {item.Quantite} {item.NomIngredient}
                      </Box>
                    ))}
                </Box>
                <Box width={'100%'}>
                  {/* LAP-733 (GE022) */}
                  <Box color={'#7f7f7f'}>{t('planMeal.instructions')}</Box>
                  {instructions.length > 0 &&
                    instructions.map((item) => (
                      <Box key={item.id}>
                        {item.Numero}. {item.Description}
                      </Box>
                    ))}
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <CustomButton
                style={{ background: '#3075dd', padding: '5px 20px' }}
                onClick={handleClickButton}
              >
                {/* LAP-733 (GE022) */}
                {t('planMeal.btnAddToList')}
              </CustomButton>
              <CustomButton
                style={{ background: '#3075dd', padding: '5px 20px' }}
                onClick={() => {
                  handleClickButton()
                  handeleEditForm()
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('planMeal.btnEditRecipe')}
              </CustomButton>
              <CustomButton
                style={{ background: '#3075dd', padding: '5px 20px' }}
                onClick={() => navigate('/recette/' + row.RecetteId)}
              >
                {/* LAP-733 (GE022) */}
                {t('planMeal.btnViewRecipe')}
              </CustomButton>
              <CustomButton
                style={{ background: 'red', padding: '5px 20px', marginLeft: '10px' }}
                onClick={handleEventDel}
              >
                {/* LAP-733 (GE022) */}
                {t('planMeal.btnDelete')}
              </CustomButton>
            </DialogActions>
          </Paper>
        </Box>
      </Popover>
    )
  }

  const lastWeek = () => {
    setWeek(
      moment()
        .clone()
        .add(weekNo - 1, 'week')
        .startOf('week')
        .format('DD') +
        '-' +
        moment()
          .clone()
          .add(weekNo - 1, 'week')
          .endOf('week')
          .format('DD MMMM yyyy'),
    )

    var weekStart = moment()
      .clone()
      .add(weekNo - 1, 'week')
      .startOf('isoWeek')
    var days = []

    for (var i = 0; i <= 6; i++) {
      days.push(moment(weekStart).add(i, 'days').format('DD MM YYYY'))
    }
    setDays(days)

    fetchOperations('', weekNo - 1)
    setWeekNo(weekNo - 1)
  }
  const nextWeek = () => {
    setWeek(
      moment()
        .clone()
        .add(weekNo + 1, 'week')
        .startOf('week')
        .format('DD') +
        '-' +
        moment()
          .clone()
          .add(weekNo + 1, 'week')
          .endOf('week')
          .format('DD MMMM yyyy'),
    )
    var weekStart = moment()
      .clone()
      .add(weekNo + 1, 'week')
      .startOf('isoWeek')
    var days = []

    for (var i = 0; i <= 6; i++) {
      days.push(moment(weekStart).add(i, 'days').format('DD MM YYYY'))
    }
    setDays(days)
    fetchOperations('', weekNo + 1)
    setWeekNo(weekNo + 1)
  }
  const nextWeekMobile = () => {
    let nextDay = moment(week, 'DD MMMM yyyy').add(1, 'days').format('DD MMMM yyyy')
    setWeek(nextDay)

    fetchOperations('', 0, moment(week, 'DD MMMM yyyy').add(1, 'days'))
  }
  const lastWeekMobile = () => {
    let nextDay = moment(week, 'DD MMMM yyyy').add(-1, 'days').format('DD MMMM yyyy')
    setWeek(nextDay)

    fetchOperations('', 0, moment(week, 'DD MMMM yyyy').add(-1, 'days'))
  }
  const currentWeek = () => {
    setWeek(
      moment().clone().startOf('week').format('DD') +
        '-' +
        moment().clone().endOf('week').format('DD MMMM yyyy'),
    )
    var weekStart = moment().clone().startOf('isoWeek')
    var days = []

    for (var i = 0; i <= 6; i++) {
      days.push(moment(weekStart).add(i, 'days').format('DD MM YYYY'))
    }
    setDays(days)
    setWeekNo(0)
    fetchOperations()
  }
  const genrateMenu = async () => {
    const response = await makeGetRequest(
      '/api/Personnal/genrate-menu/?start_date=' + weekStartDate,
      {},
      true,
    )
    if (response.status === 200) {
      alert(response.data)
      fetchOperations('', weekNo)
    }
  }
  const partagerMenu = async () => {
    const response = await makeGetRequest(
      '/api/inbox/message/partager-menu/?id=7&start_date=' + weekStartDate,
      {},
      true,
    )
    if (response.status === 200) {
      alert(response.data)
    }
  }
  useEffect(() => {
    var currentDate = moment()
    if (isMobile) {
      setWeek(currentDate.format('DD MMMM yyyy'))
      fetchOperations()
    } else {
      fetchOperations()
    }
  }, [isMobile])
  return (
    <>
      {editForm && (
        <EditOperationForm
          params={selectedRowsParams}
          setEditForm={setEditForm}
          weekNo={weekNo}
          fetchOperations={fetchOperations}
        />
      )}
      {openDetail && <PopOver setOpenDetail={setOpenDetail} ancRef={anchorRef} row={row} />}
      {openForm && (
        <CreateOperationForm
          fetchOperations={fetchOperations}
          setOpenForm={setOpenForm}
          weekNo={weekNo}
          setRow={setRow}
          row={row}
        />
      )}
      <Box
        sx={{
          minHeight: 'calc(100vh - 72px)',
          bgcolor: '#05071f',
          background: 'linear-gradient(180deg, rgba(11, 34, 69, 0.76) 0%, #05071f 42%)',
          pb: 4,
        }}
      >
      <Container maxWidth="xl" sx={{ overflow: 'hidden', pt: { xs: 1.5, md: 2.5 } }}>
        {isMobile ? (
          <Box
            padding={2}
            alignItems="self-end"
            justifyContent="space-between"
            display="flex"
            flexDirection={'column-reverse'}
          >
            <Box width={'100%'} display={'flex'} justifyContent={'space-between'} mt={2}>
              <CustomButton
                style={{ minWidth: 'unset', border: '1px solid', height: '35px' }}
                onClick={lastWeekMobile}
              >
                <KeyboardArrowLeftIcon />
              </CustomButton>
              <Box color={'white'}>{week}</Box>
              <CustomButton
                style={{ minWidth: 'unset', border: '1px solid', height: '35px' }}
                onClick={nextWeekMobile}
              >
                <KeyboardArrowRightIcon />
              </CustomButton>
            </Box>

            <Box color={'white'} display={'flex'} gap={2}>
              <PublishedWithChangesIcon onClick={genrateMenu} />
              <AddListeCourse data={menuItems} />
              <CalendarMonthIcon onClick={() => setOpenForm(true)} />

              <ShareIcon>Partager</ShareIcon>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 3,
              bgcolor: 'rgba(255,255,255,0.07)',
              border: '1px solid rgba(255,255,255,0.1)',
              boxShadow: '0 18px 44px rgba(0,0,0,0.22)',
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
              <Box>
                <Typography sx={{ color: '#ffffff', fontSize: 28, fontWeight: 950, lineHeight: 1.1 }}>
                  {/* LAP-733 (GE022) */}
                  {t('planMeal.weekMenuTitle')}
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.62)', fontSize: 14, mt: 0.6 }}>
                  {/* LAP-733 (GE022) */}
                  {t('planMeal.weekMenuHint')}
                </Typography>
              </Box>
              <Chip
                icon={<RestaurantMenuIcon sx={{ color: '#7cc6b2 !important' }} />}
                label={week}
                sx={{
                  bgcolor: 'rgba(124,198,178,0.14)',
                  color: '#ffffff',
                  border: '1px solid rgba(124,198,178,0.28)',
                  fontWeight: 850,
                  px: 1,
                }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2} sx={{ mt: 2 }} flexWrap="wrap">
              <Stack direction="row" gap={0.8}>
                <Button variant="outlined" sx={actionButtonSx} onClick={currentWeek}>
                  {/* LAP-733 (GE022) */}
                  {t('planMeal.btnToday')}
                </Button>
                <Button variant="outlined" sx={{ ...actionButtonSx, minWidth: 42, px: 0.8 }} onClick={lastWeek}>
                  <KeyboardArrowLeftIcon />
                </Button>
                <Button variant="outlined" sx={{ ...actionButtonSx, minWidth: 42, px: 0.8 }} onClick={nextWeek}>
                  <KeyboardArrowRightIcon />
                </Button>
              </Stack>
              <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
                <Button
                  variant="contained"
                  startIcon={<PublishedWithChangesIcon />}
                  onClick={genrateMenu}
                  sx={{ ...actionButtonSx, bgcolor: '#1b75d0', '&:hover': { bgcolor: '#145da8' } }}
                >
                  {/* LAP-733 (GE022) */}
                  {t('planMeal.btnGenerate')}
                </Button>
                <AddListeCourse data={menuItems} />
                <Button variant="outlined" startIcon={<CalendarMonthIcon />} onClick={() => setOpenForm(true)} sx={actionButtonSx}>
                  {/* LAP-733 (GE022) */}
                  {t('planMeal.btnPlanMeal')}
                </Button>
                <Button variant="outlined" startIcon={<ShareIcon />} onClick={partagerMenu} sx={actionButtonSx}>
                  {/* LAP-733 (GE022) */}
                  {t('planMeal.btnShare')}
                </Button>
              </Stack>
            </Stack>
          </Box>
        )}
        <Box
          mb={5}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 3,
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 18px 50px rgba(0,0,0,0.28)',
            bgcolor: 'rgba(3, 8, 32, 0.7)',
          }}
        >
          <Box sx={{ borderBottom: '1px solid rgba(255,255,255,0.14)' }} display={'flex'} justifyContent={'space-evenly'}>
            <Box sx={{ width: isMobile ? '0px' : '432px', minWidth: isMobile ? 0 : 72, bgcolor: 'rgba(255,255,255,0.05)' }}> </Box>
            {!isMobile &&
              days.map((v, i) => {
                const isToday = moment(v, 'DD MM YYYY').format('DD-MM-yyyy') === moment().format('DD-MM-yyyy')
                return (
                  <Box
                    sx={{
                      borderLeft: '1px solid rgba(255,255,255,0.1)',
                      width: '100%',
                      minWidth: isMobile ? 200 : 'unset',
                      color: 'white',
                      textAlign: 'center',
                      py: 1.15,
                      bgcolor: isToday ? 'rgba(90, 161, 216, 0.22)' : 'rgba(255,255,255,0.05)',
                    }}
                    key={i}
                  >
                    <Typography sx={{ fontWeight: 900, fontSize: 16 }}>
                      {moment(v, 'DD MM YYYY').format('DD')}
                    </Typography>
                    <Typography sx={{ color: 'rgba(255,255,255,0.62)', fontSize: 12, textTransform: 'capitalize' }}>
                      {moment(v, 'DD MM YYYY').format('ddd')}
                    </Typography>
                  </Box>
                )
              })}
          </Box>
          <Box display={'flex'} flexDirection={'row'}>
            <Box
              display={'flex'}
              sx={{ width: isMobile ? '34px' : '72px', h5: { fontSize: isMobile ? 12 : 16, letterSpacing: 0, margin: 0 } }}
              flexDirection={'column'}
            >
              <Box
                sx={{
                  color: mealColors.Matin.color,
                  display: 'flex',
                  borderBottom: '1px solid rgba(255,255,255,0.1)',
                  borderRight: '1px solid rgba(255,255,255,0.12)',
                  bgcolor: mealColors.Matin.bg,
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  h5: { transform: 'rotate(-90deg)' },
                }}
              >
                {/* LAP-733 (GE022) */}
                <h5>{t('planMeal.mealMorning')}</h5>
              </Box>
              <Box
                sx={{
                  color: mealColors.Midi.color,
                  display: 'flex',
                  borderBottom: '1px solid rgba(255,255,255,0.1)',
                  borderRight: '1px solid rgba(255,255,255,0.12)',
                  bgcolor: mealColors.Midi.bg,
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  h5: { transform: 'rotate(-90deg)' },
                }}
              >
                {/* LAP-733 (GE022) */}
                <h5>{t('planMeal.mealMidday')}</h5>
              </Box>
              <Box
                sx={{
                  color: mealColors['Après-midi'].color,
                  display: 'flex',
                  borderBottom: '1px solid rgba(255,255,255,0.1)',
                  borderRight: '1px solid rgba(255,255,255,0.12)',
                  bgcolor: mealColors['Après-midi'].bg,
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  whiteSpace: 'nowrap',
                  h5: { transform: 'rotate(-90deg)' },
                }}
              >
                {/* LAP-733 (GE022) */}
                <h5>{t('planMeal.mealAfternoon')}</h5>
              </Box>
              <Box
                sx={{
                  color: mealColors.Soir.color,
                  display: 'flex',
                  borderRight: '1px solid rgba(255,255,255,0.12)',
                  bgcolor: mealColors.Soir.bg,
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  h5: { transform: 'rotate(-90deg)' },
                }}
              >
                {/* LAP-733 (GE022) */}
                <h5>{t('planMeal.mealEvening')}</h5>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
                width: '100%',
              }}
            >
              <DragDropContext onDragEnd={(result) => onDragEnd(result, columns, setColumns)}>
                {Object.entries(columns).map(([columnId, column], index) => {
                  const mealStyle = mealColors[column.Meal] || mealColors.Midi
                  return (
                    <Box
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        minWidth: isMobile ? 200 : 'unset',
                        minHeight: '116px',
                        borderRight: '1px solid rgba(255,255,255,0.1)',
                        borderBottom: '1px solid rgba(255,255,255,0.1)',
                        background: column.box ? 'rgba(90, 161, 216, 0.15)' : 'rgba(255,255,255,0.015)',
                      }}
                      key={columnId}
                    >
                      <Box style={{ height: '100%', width: '100%' }}>
                        <Droppable droppableId={columnId} key={columnId}>
                          {(provided, snapshot) => {
                            return (
                              <div
                                className="droppable-div"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{
                                  background: snapshot.isDraggingOver ? 'rgba(124, 198, 178, 0.18)' : '',
                                  padding: 8,
                                  width: '100%',
                                  height: '100%',
                                  minHeight: '116px',
                                  cursor: 'pointer',
                                  transition: 'background-color 120ms ease',
                                }}
                                onClick={(e) => {
                                  if (e.target.className === 'droppable-div') {
                                    setRow({
                                      Meal: column.Meal,
                                      Date: column.date,
                                    })
                                    setOpenForm(true)
                                    setOpenDetail(false)
                                  }
                                }}
                              >
                                {column.items.map((item, index) => {
                                  return (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                      {(provided, snapshot) => {
                                        return (
                                          <div
                                            className="draggable-div"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                              userSelect: 'none',
                                              padding: 12,
                                              margin: '0 0 8px 0',
                                              minHeight: '70px',
                                              backgroundColor: snapshot.isDragging
                                                ? '#102f52'
                                                : mealStyle.bg,
                                              color: 'white',
                                              border: `1px solid ${mealStyle.border}`,
                                              borderRadius: 12,
                                              boxShadow: snapshot.isDragging
                                                ? '0 16px 34px rgba(0,0,0,0.34)'
                                                : '0 10px 20px rgba(0,0,0,0.16)',
                                              fontWeight: 850,
                                              ...provided.draggableProps.style,
                                            }}
                                            onClick={(e) => {
                                              setRow(item)
                                              setAnchorRef(e.target)
                                              setOpenDetail(true)
                                            }}
                                          >
                                            <Box
                                              component="span"
                                              sx={{
                                                display: 'block',
                                                color: mealStyle.color,
                                                fontSize: 11,
                                                fontWeight: 900,
                                                textTransform: 'uppercase',
                                                mb: 0.4,
                                              }}
                                            >
                                              {column.Meal}
                                            </Box>
                                            <Box component="span" sx={{ display: 'block', lineHeight: 1.2 }}>
                                              {item.RecetteNom}
                                            </Box>
                                            <Box
                                              component="span"
                                              sx={{
                                                display: 'inline-flex',
                                                mt: 1,
                                                px: 0.8,
                                                py: 0.25,
                                                borderRadius: 999,
                                                bgcolor: 'rgba(255,255,255,0.12)',
                                                color: 'rgba(255,255,255,0.76)',
                                                fontSize: 12,
                                                fontWeight: 800,
                                              }}
                                            >
                                              {item.Servir} pers.
                                            </Box>
                                          </div>
                                        )
                                      }}
                                    </Draggable>
                                  )
                                })}
                                {provided.placeholder}
                              </div>
                            )
                          }}
                        </Droppable>
                      </Box>
                    </Box>
                  )
                })}
              </DragDropContext>
            </Box>
          </Box>
        </Box>
      </Container>
      </Box>
    </>
  )
}
export default Menu
